var $body = $('body');
$(document).ready(function () {

    //Mobile Menu
    $('.menu-trigger').click(function () {
        $('body').toggleClass('nav-expand');
    });
    navbar_expand();
    $('.menu-toggle-ico').on('click', function () {
        $(this).parent().siblings('li').removeClass('sub--open').find('ul').slideUp();
        $(this).parent().toggleClass('sub--open').find('ul').first().slideToggle();
    });

    $('.scroll-bottom').bind('click', function (event) {
        $('html, body').stop().animate({
            scrollTop: ($(this).parent().parent().next('section').offset().top - 55)
        }, 800);
        event.preventDefault();
    });

    // Go to top
    $(".goto-top").click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 1000);
        return false;
    });
    // Anim slider
    $(".anim-slider").animateSlider({
        autoplay: true, //starts the autoplay 
        interval: 7000,
        loop: true,
        animations: {
            0: //Slide No1
            {
                ".banner-item": {
                    show: "fadeIn",
                    hide: "fadeOut",
                    delayShow: "delay1s"
                },
                h1: //tagName or id or class name of the element  
                {
                    show: "fadeInRight",
                    hide: "fadeOutLeft",
                    delayShow: "delay1s"
                },
                h3: //tagName or id or class name of the element  
                {
                    show: "fadeInLeft",
                    hide: "fadeOutRight",
                    delayShow: "delay1-5s"
                },
                "a.btn": //tagName or id or class name of the element  
                {
                    show: "fadeInRight",
                    hide: "fadeOutLeft",
                    delayShow: "delay1s"
                }
            },
            1: //Slide No2
            {
                ".banner-item": {
                    show: "fadeIn",
                    hide: "fadeOut",
                    delayShow: "delay1s"
                },
                h1: //tagName or id or class name of the element  
                {
                    show: "fadeInRight",
                    hide: "fadeOutLeft",
                    delayShow: "delay1s"
                },
                h3: //tagName or id or class name of the element  
                {
                    show: "fadeInLeft",
                    hide: "fadeOutRight",
                    delayShow: "delay1-5s"
                },
                "a.btn": //tagName or id or class name of the element  
                {
                    show: "fadeInRight",
                    hide: "fadeOutLeft",
                    delayShow: "delay1s"
                }
            }
        }
    });
    //Project carousel    
    var projectSlider = $('.project-carousel');
    if (projectSlider.length) {
        if (projectSlider.find('.item').length > 1) {
            projectSlider.owlCarousel({
                autoplay: true,
                autoplayTimeout: 2000,
                autoplayHoverPause: true,
                items: 1,
                loop: true

            });
        } else {
            projectSlider.show();
        }
    }
    //client carousel    
    var clientSlider = $('.client-carousel');
    if (clientSlider.length) {
        if (clientSlider.find('.item').length > 1) {
            clientSlider.owlCarousel({
                navigation: true, // Show next and prev buttons
                loop: true,
                nav: false,
                dots: false,
                autoplay: true,
                autoplayTimeout: 2000,
                autoplayHoverPause: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    575: {
                        items: 3
                    },
                    991: {
                        items: 5
                    }
                }
            });
        } else {
            clientSlider.show();
        }
    }
    //timetable-slider
    var testimonialSlider = $('.testimonial-slider');
    if (testimonialSlider.length) {
        if (testimonialSlider.find('.testimonial-slide').length > 1) {
            testimonialSlider.owlCarousel({
                nav: true,
                dots: false,
                loop: true,
                animateOut: 'fadeOut',
                items: 1
            });
        } else {
            testimonialSlider.show();
        }
    }
    //counter section
    $('.counter').counterUp({
        delay: 30,
        time: 3000
    });
    if ($(window).width() >= 768 && $(window).width() < 1025) {
        $(".has-sub-menu a").one("click", false, function (e) {
            if ("ontouchstart" in document.documentElement) {
                e.preventDefault();
            }
        });
        $(".has-sub-menu a").on("touchstart", function (e) {
            $(this).children('.sub-menu-list').toggleClass('has-menu-open');
        });

        $(document).on("touchstart click", function (e) {
            container = $('.navigation');
            contactInfo = $('.navigation a');
            if (!container.is(e.target) && container.has(e.target).length === 0 && !contactInfo.is(e.target) && contactInfo.has(e.target).length === 0) {
                $(".sub-menu-list").removeClass('has-menu-open');
            }
        });
    }
});
$(window).on('load', function () {
    portfolio();
});
$(window).resize(function () {
    navbar_expand();
});
var stickyOffset = $('header').height();
var previousScroll = 0;
$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    // Fixed Menu
    if (scroll >= 100) {
        $('body').addClass('fixed-header');
    } else {
        $('body').removeClass('fixed-header');
    }

    /* for go to top arrow */
    var currentScroll = $(this).scrollTop();
    if (currentScroll > previousScroll) {
        if (scroll >= stickyOffset + 100) {
            $('.goto-top').addClass('visible');
        }
    } else {
        $('.goto-top').removeClass('visible');
    }

    var $copy = $('.sub-footer').outerHeight();
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 35) {
        $('.goto-top').css("bottom", $copy + 5);
    } else {
        $('.goto-top').css("bottom", "30px");
    }
});
$(document).on("touchstart click", function (e) {
    container = $('');
    contactInfo = $('');
    if (!container.is(e.target) // if the target of the click isn't the container...
        &&
        container.has(e.target).length === 0 && !contactInfo.is(e.target) && contactInfo.has(e.target).length === 0) {
        // Action Which you want to perform   
    }
});

function win_height() {
    return $(window).outerHeight();
}

function win_width() {
    return $(window).width();
}

function header_height() {
    return $('header.page').outerHeight();
}

function navbar_expand() {
    if ($(window).width() <= 991) {
        $('.menu-toggle-ico').click(function () {
            $(this).toggleClass('rotate-ico');
        });
    }
}

function portfolio() {
    /****Isotope plugins****/
    $grid = $('.list').isotope({
        // options
        itemSelector: '.list-item',
        // set layoutMode
        layoutMode: 'fitRows',
        getSortData: {
            filename: '.file-name'
        },
        // options for cellsByRow layout mode
        fitRows: {
            gutter: 7.5
        }
    });
    // filter items on button click
    $('.js-filter').on('click', 'button', function () {
        var filterValue = $(this).attr('data-filter');
        $grid.isotope({
            filter: filterValue
        });
        $('.js-filter button').removeClass('is-active');
        $(this).addClass('is-active');
    });
    $('.button-switch').on('click', function () {
        var sortValue = $(this).attr('data-sort-value');
        $(this).toggleClass("on");
        var direction = $(this).attr('data-sort-direction');

        /* convert it to a boolean */
        var isAscending = (direction === 'asc');
        var newDirection = (isAscending) ? 'desc' : 'asc';

        /* pass it to isotope */
        $grid.isotope({
            sortBy: sortValue,
            sortAscending: isAscending
        });
        $(this).attr('data-sort-direction', newDirection);

    });
    //Fancybox section
    $('[data-fancybox="portfolio"]').fancybox({
        transitionDuration: 700,
        animationDuration: 700,
        animationEffect: "fade",
        buttons: [
            'slideShow',
            'fullScreen',
            'share',
            'download',
            'zoom',
            'close',
            'thumbs'
        ],
        caption: function () {
            return $(this).siblings('.title').html();
        }
    });
}